import * as THREE from 'three';
import { useEffect, useState } from 'react';

export const BlackPlastic = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0,
  metalness: 0,
  clearcoat: 1,
  clearcoatRoughness: 0,
  emissive: '#FFFFFF',
  emissiveIntensity: 0.15,
});

export const PaintColorMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0,
  metalness: 0,
  clearcoat: 1,
  clearcoatRoughness: 0,
  emissive: '#FFFFFF',
  emissiveIntensity: 0.15,
  name: 'paint',
});

export const PaintColorMaterialDark = new THREE.MeshPhysicalMaterial({
  color: '#000000',
  roughness: 0,
  metalness: 0,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const WoodTopPaintColorMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0,
  metalness: 0,
  clearcoat: 1,
  clearcoatRoughness: 0,
  emissive: '#FFFFFF',
  emissiveIntensity: 0.15,
  name: 'paint',
});

export const Mattress = new THREE.MeshPhysicalMaterial({
  color: '#eeeeee',
  roughness: 1,
  metalness: 0,
});

export const WoodTopMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
  // emissive: "#FFFFFF",
  // emissiveIntensity: 0,
});

export const Bronze = (envMap) =>
  new THREE.MeshPhysicalMaterial({
    color: '#695f49', // #5c5444
    roughness: 0.2,
    metalness: 1.0,
    clearcoat: 0.5,
    clearcoatRoughness: 0.1,
    envMap,
  });

export const Silver = (envMap) =>
  new THREE.MeshPhysicalMaterial({
    color: '#A9A9A9', //#D3D3D3
    roughness: 0.3,
    metalness: 1.0,
    clearcoat: 0.5,
    clearcoatRoughness: 0.1,
    envMap,
  });

export const UpholsteryMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const LegFinishMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const CushionMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const ChairFrameMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const RetreatFabricMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const RetreatLegMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const TurnedLegMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const MetalLegMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const HeadboardFabricMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const Buffer = new THREE.MeshPhysicalMaterial({
  color: '#1f1f1f',
  roughness: 0.9,
  metalness: 0.75,
  clearcoat: 0.5,
  clearcoatRoughness: 0.5,
});

export const defaultMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const Chrome = (envMap) =>
  new THREE.MeshPhysicalMaterial({
    color: '#888888',
    roughness: 0,
    metalness: 1,
    clearcoat: 1,
    clearcoatRoughness: 0,
    envMap,
  });

export const Bedsheet = new THREE.MeshPhysicalMaterial({
  color: '#e8e8e8',
  roughness: 1,
  metalness: 0,
  clearcoat: 0,
  clearcoatRoughness: 0,
});

export const BlackFeet = new THREE.MeshPhysicalMaterial({
  color: '#000',
  roughness: 1,
  metalness: 0,
  clearcoat: 0.5,
  clearcoatRoughness: 0.5,
});

export const allFinishes = [
  { id: 1, value: 'Basket Weave : Milk' },
  { id: 2, value: 'Basket Weave : Vast Sky' },
  { id: 3, value: 'Beach House Linen : Peacock' },
  { id: 4, value: 'Beach House Linen : Vast Sky' },
  { id: 5, value: 'Boats By The Yard : Gladiola' },
  { id: 6, value: 'Boomerang : Cloud' },
  { id: 7, value: 'Boomerang: Sage' },
  { id: 8, value: 'Branch Out : Bermuda Beach' },
  { id: 9, value: 'Branch Out : Peacock' },
  { id: 10, value: 'Cast-A-Net : Wheatgrass' },
  { id: 11, value: 'Cast-A-Net : Lagoon' },
  { id: 12, value: 'Cast-A-Net : Marine' },
  { id: 13, value: 'Checkmate : Denim' },
  { id: 14, value: 'Checkmate : Sour Apple' },
  { id: 15, value: 'Clambake: Bluebell' },
  { id: 16, value: 'Clambake: Marine' },
  { id: 17, value: 'Clambake: Sprout' },
  { id: 18, value: 'Crazy Daisy : Nikko Blue' },
  { id: 19, value: 'Crazy Daisy : Wild Salmon' },
  { id: 20, value: 'Dilly : Bluebell' },
  { id: 21, value: 'Fireworks : Nikko Blue' },
  { id: 22, value: 'Fireworks : Wild Salmon' },
  { id: 23, value: 'Freckles : Greenery' },
  { id: 24, value: 'Freckles : Skyline' },
  { id: 25, value: 'Freckles : Zinnia' },
  { id: 26, value: 'Grand Mum : Oyster' },
  { id: 27, value: 'Grand Mum : Sun' },
  { id: 28, value: 'Hotty Dotty : Ale' },
  { id: 29, value: 'Hydrangea Holiday : Bluestone' },
  { id: 30, value: 'Hydrangea Holiday : Marine' },
  { id: 31, value: 'In Stitches : Bluebell' },
  { id: 32, value: 'Knotty Loop : Academy' },
  { id: 33, value: 'Knotty Loop : Bluestone' },
  { id: 34, value: 'Knotty Loop : Marine' },
  { id: 35, value: 'Laguna : Marine' },
  { id: 36, value: 'Laguna : Pear' },
  { id: 37, value: 'Lavishly : Marine' },
  { id: 38, value: 'Lavishly : Shortcake' },
  { id: 39, value: 'Lavishly : Skyline' },
  { id: 40, value: 'Leaflette : Marine' },
  { id: 41, value: 'Leaflette : Porch' },
  { id: 42, value: "Let's Grove : Marine" },
  { id: 43, value: "Let's Grove : Sage" },
  { id: 44, value: 'Lucky Leaf : Marine' },
  { id: 45, value: 'Mix Tape : Lagoon' },
  { id: 46, value: 'Mix Tape : Marine' },
  { id: 47, value: 'Mix Tape : Ryegrass' },
  { id: 48, value: 'Mix Tape : Storm' },
  { id: 49, value: 'Oxford Stripe : Greenery' },
  { id: 50, value: 'Oxford Stripe : Marine' },
  { id: 51, value: 'Oxford Stripe : Oyster' },
  { id: 52, value: 'Oxford Stripe : Zinnia' },
  { id: 53, value: 'Pebble Washed : Bisque' },
  { id: 54, value: 'Pebble Washed : Sage' },
  { id: 55, value: 'Plain Jane : Academy' },
  { id: 56, value: 'Plain Jane : Bisque' },
  { id: 57, value: 'Plain Jane : Bluestone' },
  { id: 58, value: 'Plain Jane : Bright White' },
  { id: 59, value: 'Plain Jane : Skyline' },
  { id: 60, value: 'Plain Jane : Surf' },
  { id: 61, value: 'Raine : Academy' },
  { id: 62, value: 'Raine : Good Egg' },
  { id: 63, value: 'Raine : Lagoon' },
  { id: 64, value: 'Raine : Wheatgrass' },
  { id: 65, value: 'Sea Biscuit : Bluestone' },
  { id: 66, value: 'Sea Biscuit : Oyster' },
  { id: 67, value: 'Sea Biscuit : Porch' },
  { id: 68, value: 'Sea Biscuit : True Blue' },
  { id: 69, value: 'Shabby Stripes : Bluestone' },
  { id: 70, value: 'Shell Game : Lagoon' },
  { id: 71, value: 'Shell Game : Marine' },
  { id: 72, value: 'Shore-Bet : Winter' },
  { id: 73, value: 'Shore-Bet : Bermuda Beach' },
  { id: 74, value: 'Shore-Bet : Bluebell' },
  { id: 75, value: 'Shore-Bet : Bright White' },
  { id: 76, value: 'Shore-Bet : Nantucket' },
  { id: 77, value: 'Shore-Bet : Sprout' },
  { id: 78, value: 'Shore-Bet : Surf' },
  { id: 79, value: 'Shore-Bet : Vast Sky' },
  { id: 80, value: 'Simply Soft : Cloud' },
  { id: 81, value: 'Simply Soft : Marine' },
  { id: 82, value: 'Simply Soft : Oyster' },
  { id: 83, value: 'Thatch : Bluebell' },
  { id: 84, value: 'Thread Up : Shortcake' },
  { id: 85, value: 'Tweedy : Bisque' },
  { id: 86, value: 'Tweedy : Bluestone' },
  { id: 87, value: 'Tweedy : Oyster' },
  { id: 88, value: 'Tweet Suite: Porch' },
  { id: 89, value: 'Very Velvet : Marine' },
  { id: 90, value: 'Very Velvet : Sage' },
  { id: 91, value: 'Washed Out : Vast Sky' },
  { id: 92, value: 'Well-Worn : Vast Sky' },
  { id: 93, value: 'Zig Zag : Cloud' },
  { id: 94, value: 'Zig Zag : Skyline' },
  { id: 95, value: 'Bronzed Metal' },
  { id: 96, value: 'Slate Metal' },
  { id: 97, value: 'Academy' },
  { id: 98, value: 'Bermuda Beach' },
  { id: 99, value: 'Bisque' },
  { id: 100, value: 'Blackbird' }, // #13171c
  { id: 101, value: 'Bluebell' },
  { id: 102, value: 'Bluestone' },
  { id: 103, value: 'Bright White' },
  { id: 104, value: 'Cloud' },
  { id: 105, value: 'Gladiola' },
  { id: 106, value: 'Joy' },
  { id: 107, value: 'Lagoon' },
  { id: 108, value: 'Marine' },
  { id: 109, value: 'Milk' },
  { id: 110, value: 'Oyster' },
  { id: 111, value: 'Peacock' },
  { id: 112, value: 'Porch' },
  { id: 113, value: 'Rhubarb' },
  { id: 114, value: 'Ryegrass' },
  { id: 115, value: 'Sage' },
  { id: 116, value: 'Shortcake' },
  { id: 117, value: 'Skyline' },
  { id: 118, value: 'Slate' },
  { id: 119, value: 'Sorbet' },
  { id: 120, value: 'Sprout' },
  { id: 121, value: 'Storm' },
  { id: 122, value: 'Sun' },
  { id: 123, value: 'Surf' },
  { id: 124, value: 'Tomato' },
  { id: 125, value: 'Vast Sky' },
  { id: 126, value: 'Zinnia' },
  { id: 127, value: 'Hand Planed Bourbon Cherry' },
  { id: 128, value: 'Natural Cherry' },
  { id: 129, value: 'Natural Maple' },
  { id: 130, value: 'Natural Quarter Sawn White Oak' },
  { id: 131, value: 'Matte Glazed White Oak' },
  { id: 132, value: 'Natural cherry' },
  { id: 133, value: 'Coconut Husk' },
  { id: 134, value: 'Fruitwood' },
  { id: 135, value: 'Java' },
  { id: 136, value: 'Limewash' },
  { id: 137, value: 'Natural Maple' },
  { id: 138, value: 'Nordic' },
  { id: 139, value: 'Sea Salt' },
  { id: 140, value: 'No Cushion' },
  { id: 141, value: 'Painted' },

  { id: 'Walnut Cocoa', value: 'Walnut Cocoa' },
  { id: 'Sand', value: 'Sand' },
  { id: 'Ash', value: 'Ash' },
  { id: 'Walnut - Cocoa', value: 'Walnut Cocoa' },
  { id: 'Rift Sawn White Oak - Sand', value: 'Sand' },
  { id: 'Rift Sawn White Oak - Ash', value: 'Ash' },
];

export const allFinishesCustom = [
  { id: 1, value: 'Basket Weave Milk' },
  { id: 2, value: 'Basket Weave Vast Sky' },
  { id: 3, value: 'Beach House Linen Peacock' }, // not found in new data
  { id: 4, value: 'Beach House Linen Vast Sky' },
  { id: 5, value: 'Boats By The Yard Gladiola' },
  { id: 6, value: 'Boomerang Cloud' },
  { id: 7, value: 'Boomerang Sage' },
  { id: 8, value: 'Branch Out Bermuda Beach' },
  { id: 9, value: 'Branch Out Peacock' },
  { id: 10, value: 'Cast A Net Wheatgrass' },

  { id: 11, value: 'Cast A Net Lagoon' },
  { id: 12, value: 'Cast A Net Marine' },
  { id: 13, value: 'Checkmate Denim' },
  { id: 14, value: 'Checkmate Sour Apple' },
  { id: 15, value: 'Clambake Bluebell' },
  { id: 16, value: 'Clambake Marine' },
  { id: 17, value: 'Clambake Sprout' },
  { id: 18, value: 'Crazy Daisy Nikko Blue' },
  { id: 19, value: 'Crazy Daisy Wild Salmon' },
  { id: 20, value: 'Dilly Bluebell' },

  { id: 21, value: 'Fireworks Nikko Blue' },
  { id: 22, value: 'Fireworks Wild Salmon' },
  { id: 23, value: 'Freckles Greenery' },
  { id: 24, value: 'Freckles Skyline' },
  { id: 25, value: 'Freckles Zinnia' },
  { id: 26, value: 'Grand Mum Oyster' },
  { id: 27, value: 'Grand Mum Sun' },
  { id: 28, value: 'Hotty Dotty Ale' },
  { id: 29, value: 'Hydrangea Holiday Bluestone' },
  { id: 30, value: 'Hydrangea Holiday Marine' },

  { id: 31, value: 'In Stitches : Bluebell' }, // not found in new data
  { id: 32, value: 'Knotty Loop Academy' },
  { id: 33, value: 'Knotty Loop Bluestone' },
  { id: 34, value: 'Knotty Loop Marine' },
  { id: 35, value: 'Laguna Marine' },
  { id: 36, value: 'Laguna Pear' },
  { id: 37, value: 'Lavishly Marine' },
  { id: 38, value: 'Lavishly Shortcake' },
  { id: 39, value: 'Lavishly Skyline' },
  { id: 40, value: 'Leaflette Marine' },

  { id: 41, value: 'Leaflette Porch' },
  { id: 42, value: "Lets Grove Marine" },
  { id: 43, value: "Lets Grove Sage" },
  { id: 44, value: 'Lucky Leaf Marine' },
  { id: 45, value: 'Mix Tape Lagoon' },
  { id: 46, value: 'Mix Tape Marine' },
  { id: 47, value: 'Mix Tape Ryegrass' },
  { id: 48, value: 'Mix Tape Storm' },
  { id: 49, value: 'Oxford Greenery' },
  { id: 50, value: 'Oxford Marine' },

  { id: 51, value: 'Oxford Oyster' },
  { id: 52, value: 'Oxford Zinnia' },
  { id: 53, value: 'Pebble Washed Bisque' },
  { id: 54, value: 'Pebble Washed Sage' },
  { id: 55, value: 'Plain Jane Academy' },
  { id: 56, value: 'Plain Jane Bisque' },
  { id: 57, value: 'Plain Jane Bluestone' },
  { id: 58, value: 'Plain Jane Bright White' },
  { id: 59, value: 'Plain Jane Skyline' },
  { id: 60, value: 'Plain Jane Surf' },

  { id: 61, value: 'Raine Academy' },
  { id: 62, value: 'Raine Good Egg' },
  { id: 63, value: 'Raine Lagoon' },
  { id: 64, value: 'Raine Wheatgrass' },
  { id: 65, value: 'Sea Biscuit Bluestone' },
  { id: 66, value: 'Sea Biscuit Oyster' },
  { id: 67, value: 'Sea Biscuit Porch' },
  { id: 68, value: 'Sea Biscuit : True Blue' }, // not found in new data
  { id: 69, value: 'Shabby Striped Bluestone' },
  { id: 70, value: 'Shell Game Lagoon' },

  { id: 71, value: 'Shell Game Marine' },
  { id: 72, value: 'Shore Bet Winter' },
  { id: 73, value: 'Shore Bet Bermuda Beach' },
  { id: 74, value: 'Shore Bet Bluebell' },
  { id: 75, value: 'Shore Bet Bright White' },
  { id: 76, value: 'Shore Bet Nuntucket' },
  { id: 77, value: 'Shore Bet Sprout' },
  { id: 78, value: 'Shore Bet Surf' },
  { id: 79, value: 'Shore Bet Vast Sky' },
  { id: 80, value: 'Simply Soft Cloud' },

  { id: 81, value: 'Simply Soft Marine' },
  { id: 82, value: 'Simply Soft Oyster' },
  { id: 83, value: 'Thatch Bluebell' },
  { id: 84, value: 'Thread Up Short Cake' },
  { id: 85, value: 'Tweedy Bisque' },
  { id: 86, value: 'Tweedy Bluestone' },
  { id: 87, value: 'Tweedy Oyster' },
  { id: 88, value: 'Tweet Suite Porch' },
  { id: 89, value: 'Very Velvet Marine' },
  { id: 90, value: 'Very Velvet Sage' },

  { id: 91, value: 'Washed Out Vast Sky' },
  { id: 92, value: 'Well Worn Vast Sky' },
  { id: 93, value: 'Zig Zag Cloud' },
  { id: 94, value: 'Zig Zag Skyline' },

  { id: 95, value: 'Bronzed Metal' }, // not found in new data
  { id: 96, value: 'Slate Metal' }, // not found in new data
  { id: 97, value: 'Academy' },
  { id: 98, value: 'Bermuda Beach' },
  { id: 99, value: 'Bisque' },
  { id: 100, value: 'Blackbird' }, // #13171c

  { id: 101, value: 'Bluebell' },
  { id: 102, value: 'Bluestone' },
  { id: 103, value: 'Bright White' },
  { id: 104, value: 'Cloud' },
  { id: 105, value: 'Gladiola' },
  { id: 106, value: 'Joy' },
  { id: 107, value: 'Lagoon' },
  { id: 108, value: 'Marine' },
  { id: 109, value: 'Milk' },
  { id: 110, value: 'Oyster' },

  { id: 111, value: 'Peacock' },
  { id: 112, value: 'Porch' },
  { id: 113, value: 'Rhubarb' },
  { id: 114, value: 'Ryegrass' },
  { id: 115, value: 'Sage' },
  { id: 116, value: 'Shortcake' },
  { id: 117, value: 'Skyline' },
  { id: 118, value: 'Slate' },
  { id: 119, value: 'Sorbet' },
  { id: 120, value: 'Sprout' },

  { id: 121, value: 'Storm' },
  { id: 122, value: 'Sun' },
  { id: 123, value: 'Surf' },
  { id: 124, value: 'Tomato' },
  { id: 125, value: 'Vast Sky' },
  { id: 126, value: 'Zinnia' },
  { id: 127, value: 'Hand Planed Bourbon Cherry' },
  { id: 128, value: 'Natural Cherry' },
  { id: 129, value: 'Natural Maple' },
  { id: 130, value: 'Natural Quarter Sawn White Oak' },

  { id: 131, value: 'Matte Glazed White Oak' },
  { id: 132, value: 'Natural cherry' },
  { id: 133, value: 'Coconut Husk' },
  { id: 134, value: 'Fruitwood' },
  { id: 135, value: 'Java' },
  { id: 136, value: 'Limewash' },
  { id: 137, value: 'Natural Maple' },
  { id: 138, value: 'Nordic' },
  { id: 139, value: 'Sea Salt' },
  { id: 140, value: 'No Cushion' },
  { id: 141, value: 'Painted' },

  // { id: 'Natural Maple', value: 'Natural Maple' },
  // { id: 'Natural Cherry', value: 'Natural Cherry' },
  // { id: 'Natural Quarter Sawn White Oak', value: 'Natural Quarter Sawn White Oak' },
  // { id: 'Matte Glazed White Oak', value: 'Matte Glazed White Oak' },
  // { id: 'Hand Planed Bourbon Cherry', value: 'Hand Planed Bourbon Cherry' },
  { id: 'Walnut Cocoa', value: 'Walnut - Cocoa' },
  { id: 'Sand', value: 'Rift Sawn White Oak - Sand' },
  { id: 'Ash', value: 'Rift Sawn White Oak - Ash' },
  { id: 'Walnut - Cocoa', value: 'Walnut - Cocoa' },
  { id: 'Rift Sawn White Oak - Sand', value: 'Rift Sawn White Oak - Sand' },
  { id: 'Rift Sawn White Oak - Ash', value: 'Rift Sawn White Oak - Ash' },
  { id: 'Polished Nickel', value: 'Polished Nickel' },
  { id: 'Golden Champagne', value: 'Golden Champagne' },
  { id: 'Wood Knobs', value: 'Wood Knobs' },

  // New data : Cushion finishes
  {id: 'Basket Weave: Milk', value: 'Basket Weave Milk'},
  {id: 'Basket Weave: Vast Sky', value: 'Basket Weave Vast Sky'},
  {id: 'Beach House Linen: Vast Sky', value: 'Beach House Linen Vast Sky'},
  {id: 'Boats By The Yard: Gladiola', value: 'Boats By The Yard Gladiola'},
  {id: 'Boomerang: Cloud', value: 'Boomerang Cloud'},
  {id: 'Boomerang: Sage', value: 'Boomerang Sage'},
  {id: 'Branch Out: Bermuda Beach', value: 'Branch Out Bermuda Beach'},
  {id: 'Branch Out: Peacock', value: 'Branch Out Peacock'},
  {id: 'Cast-a-Net: Wheatgrass', value: 'Cast A Net Wheatgrass'},
  {id: 'Cast a Net: Wheatgrass', value: 'Cast A Net Wheatgrass'},

  {id: 'Cast a Net: Lagoon', value: 'Cast A Net Lagoon'},
  {id: 'Cast-a-Net: Lagoon', value: 'Cast A Net Lagoon'},
  {id: 'Cast a Net: Marine', value: 'Cast A Net Marine'},
  {id: 'Cast-a-Net: Marine', value: 'Cast A Net Marine'}, 
  {id: 'Checkmate: Denim', value: 'Checkmate Denim'},
  {id: 'Checkmate: Sour Apple', value: 'Checkmate Sour Apple'},
  {id: 'Clambake: Bluebell', value: 'Clambake Bluebell'},
  {id: 'Clambake: Marine', value: 'Clambake Marine'},
  {id: 'Clambake: Sprout', value: 'Clambake Sprout'},
  {id: 'Crazy Daisy: Nikko Blue', value: 'Crazy Daisy Nikko Blue'},
  {id: 'Crazy Daisy: Wild Salmon', value: 'Crazy Daisy Wild Salmon'},
  {id: 'Dilly: Bluebell', value: 'Dilly Bluebell'},

  {id: 'Fireworks: Nikko Blue', value: 'Fireworks Nikko Blue'},
  {id: 'Fireworks: Wild Salmon', value: 'Fireworks Wild Salmon'},
  {id: 'Freckles: Greenery', value: 'Freckles Greenery'},
  {id: 'Freckles: Skyline', value: 'Freckles Skyline'},
  {id: 'Freckles: Zinnia', value: 'Freckles Zinnia'},
  {id: 'Grand Mum: Oyster', value: 'Grand Mum Oyster'},
  {id: 'Grand Mum: Sun', value: 'Grand Mum Sun'},
  {id: 'Hotty Dotty: Ale', value: 'Hotty Dotty Ale'},
  {id: 'Hydrangea Holiday: Bluestone', value: 'Hydrangea Holiday Bluestone'},
  {id: 'Hydrangea Holiday: Marine', value: 'Hydrangea Holiday Marine'},

  {id: 'Knotty Loop: Academy', value: 'Knotty Loop Academy'},
  {id: 'Knotty Loop: Bluestone', value: 'Knotty Loop Bluestone'},
  {id: 'Knotty Loop: Marine', value: 'Knotty Loop Marine'},
  {id: 'Laguna: Marine', value: 'Laguna Marine'},
  {id: 'Laguna: Pear', value: 'Laguna Pear'},
  {id: 'Lavishly: Marine', value: 'Lavishly Marine'},
  {id: 'Lavishly: Shortcake', value: 'Lavishly Shortcake'},
  {id: 'Lavishly: Skyline', value: 'Lavishly Skyline'},
  {id: 'Leaflette: Marine', value: 'Leaflette Marine'},

  {id: 'Leaflette: Porch', value: 'Leaflette Porch'},
  {id: "Let's Grove: Marine", value: "Lets Grove Marine"},
  {id: "Let's Grove: Sage", value: "Lets Grove Sage"},
  {id: 'Lucky Leaf: Marine', value: 'Lucky Leaf Marine'},
  {id: 'Mix Tape: Lagoon', value: 'Mix Tape Lagoon'},
  {id: 'Mix Tape: Marine', value: 'Mix Tape Marine'},
  {id: 'Mix Tape: Ryegrass', value: 'Mix Tape Ryegrass'},
  {id: 'Mix Tape: Storm', value: 'Mix Tape Storm'},
  {id: 'Oxford Stripe: Greenery', value: 'Oxford Greenery'},
  {id: 'Oxford Stripe: Marine', value: 'Oxford Marine'},

  {id: 'Oxford Stripe: Oyster', value: 'Oxford Oyster'},
  {id: 'Oxford Stripe: Zinnia', value: 'Oxford Zinnia'},
  {id: 'Pebble Washed: Bisque', value: 'Pebble Washed Bisque'},
  {id: 'Pebble Washed: Sage', value: 'Pebble Washed Sage'},
  {id: 'Plain Jane: Academy', value: 'Plain Jane Academy'},
  {id: 'Plain Jane: Bisque', value: 'Plain Jane Bisque'},
  {id: 'Plain Jane: Bluestone', value: 'Plain Jane Bluestone'},
  {id: 'Plain Jane: Bright White', value: 'Plain Jane Bright White'},
  {id: 'Plain Jane: Skyline', value: 'Plain Jane Skyline'},
  {id: 'Plain Jane: Surf', value: 'Plain Jane Surf'},

  {id: 'Raine: Academy', value: 'Raine Academy'},
  {id: 'Raine: Good Egg', value: 'Raine Good Egg'},
  {id: 'Raine: Lagoon', value: 'Raine Lagoon'},
  {id: 'Raine: Wheatgrass', value: 'Raine Wheatgrass'},
  {id: 'Sea Biscuit: Bluestone', value: 'Sea Biscuit Bluestone'},
  {id: 'Sea Biscuit: Oyster', value: 'Sea Biscuit Oyster'},
  {id: 'Sea Biscuit: Porch', value: 'Sea Biscuit Porch'},
  {id: 'Shabby Stripes: Bluestone', value: 'Shabby Striped Bluestone'},
  {id: 'Shell Game: Lagoon', value: 'Shell Game Lagoon'},

  {id: 'Shell Game: Marine', value: 'Shell Game Marine'},
  {id: 'Shore-Bet: Winter', value: 'Shore Bet Winter'},
  {id: 'Shore-Bet: Bermuda Beach', value: 'Shore Bet Bermuda Beach'},
  {id: 'Shore-Bet: Bluebell', value: 'Shore Bet Bluebell'},
  {id: 'Shore-Bet: Bright White', value: 'Shore Bet Bright White'},
  {id: 'Shore-Bet: Nantucket', value: 'Shore Bet Nuntucket'},
  {id: 'Shore-Bet: Sprout', value: 'Shore Bet Sprout'},
  {id: 'Shore-Bet: Surf', value: 'Shore Bet Surf'},
  {id: 'Shore-Bet: Vast Sky', value: 'Shore Bet Vast Sky'},
  {id: 'Simply Soft: Cloud', value: 'Simply Soft Cloud'},

  {id: 'Simply Soft: Marine', value: 'Simply Soft Marine'},
  {id: 'Simply Soft: Oyster', value: 'Simply Soft Oyster'},
  {id: 'Thatch: Bluebell', value: 'Thatch Bluebell'},
  {id: 'Thread Up: Shortcake', value: 'Thread Up Short Cake'},
  {id: 'Tweedy: Bisque', value: 'Tweedy Bisque'},
  {id: 'Tweedy: Bluestone', value: 'Tweedy Bluestone'},
  {id: 'Tweedy: Oyster', value: 'Tweedy Oyster'},
  {id: 'Tweet Suite: Porch', value: 'Tweet Suite Porch'},
  {id: 'Very Velvet: Marine', value: 'Very Velvet Marine'},
  {id: 'Very Velvet: Sage', value: 'Very Velvet Sage'},
  {id: 'Washed Out: Vast Sky', value: 'Washed Out Vast Sky'},
  {id: 'Well-Worn: Vast Sky', value: 'Well Worn Vast Sky'},
  {id: 'Zig Zag: Cloud', value: 'Zig Zag Cloud'},
  {id: 'Zig Zag: Skyline', value: 'Zig Zag Skyline'},

  { id: 'Academy', value: 'Academy' },
  { id: 'Bermuda Beach', value: 'Bermuda Beach' },
  { id: 'Bisque', value: 'Bisque' },
  { id: 'Blackbird', value: 'Blackbird' }, // #13171c

  { id: 'Bluebell', value: 'Bluebell' },
  { id: 'Bluestone', value: 'Bluestone' },
  { id: 'Bright White', value: 'Bright White' },
  { id: 'Cloud', value: 'Cloud' },
  { id: 'Gladiola', value: 'Gladiola' },
  { id: 'Joy', value: 'Joy' },
  { id: 'Lagoon', value: 'Lagoon' },
  { id: 'Marine', value: 'Marine' },
  { id: 'Milk', value: 'Milk' },
  { id: 'Oyster', value: 'Oyster' },

  { id: 'Peacock', value: 'Peacock' },
  { id: 'Porch', value: 'Porch' },
  { id: 'Rhubarb', value: 'Rhubarb' },
  { id: 'Ryegrass', value: 'Ryegrass' },
  { id: 'Sage', value: 'Sage' },
  { id: 'Shortcake', value: 'Shortcake' },
  { id: 'Skyline', value: 'Skyline' },
  { id: 'Slate', value: 'Slate' },
  { id: 'Sorbet', value: 'Sorbet' },
  { id: 'Sprout', value: 'Sprout' },

  { id: 'Storm', value: 'Storm' },
  { id: 'Sun', value: 'Sun' },
  { id: 'Surf', value: 'Surf' },
  { id: 'Tomato', value: 'Tomato' },
  { id: 'Vast Sky', value: 'Vast Sky' },
  { id: 'Zinnia', value: 'Zinnia' },
  { id: 'Hand Planed Bourbon Cherry', value: 'Hand Planed Bourbon Cherry' }, 
  { id: 'Natural Cherry', value: 'Natural Cherry' },
  { id: 'Natural Maple', value: 'Natural Maple' },
  { id: 'Natural Quarter Sawn White Oak', value: 'Natural Quarter Sawn White Oak' },

  { id: 'Matte Glazed White Oak', value: 'Matte Glazed White Oak' },
  { id: 'Coconut Husk', value: 'Coconut Husk' },
  { id: 'Fruitwood', value: 'Fruitwood' },
  { id: 'Java', value: 'Java' },
  { id: 'Limewash', value: 'Limewash' },
  { id: 'Nordic', value: 'Nordic' },
  { id: 'Sea Salt', value: 'Sea Salt' },
  { id: 'No Cushion', value: 'No Cushion' },
  { id: 'Painted', value: 'Painted' },

];


export const allLabelsCustom = [
  { id: 'Upholstery', value: 'Upholstery Fabric' },
  { id: 'Headboard Fabric', value: 'Upholstery Fabric' },
  { id: 'Welt', value: 'Welt Fabric' },
  { id: 'Cushion', value: 'Upholstery Fabric' },
  { id: 'Metal Legs', value: 'Wood Finish' },
  { id: 'Leg Finish + Paint Color', value: 'Wood Finish' },
  { id: 'Leg Finish', value: 'Wood Finish' },
  { id: 'Paint Color', value: 'Paint Color' },
  { id: 'Wood Top', value: 'Wood Top' },
  { id: 'Chair Frame', value: 'Wood Finish' },
  { id: 'Wood Finish', value: 'Wood Finish' },
  { id: 'Turned Leg Finish', value: 'Wood Finish' },
  { id: 'Hardware Style', value: 'Hardware Style'},
  { id: 'Shelf Paint', value: 'Wood Top'}
];